import { RelatedLP } from '../../../related/RelatedPages';
export default function Page() { return <RelatedLP slug="the-butler" locale="en" />; }
